export default __webpack_public_path__ + "images/3dda1fe7cc8fd474bda27512b31c1cb2-6_tablet_1067x470.jpg";